// The failing Companies House check card: what Re-check now's answer means, from the trust-score review card's rescore refusals.
// Its view of its job is the failing behaviour score card's failingView (the review queue fills both the same way). Pure, so
// the unit tests import it.
import { rescoreResult, type LambdaAnswer, type RescoreResult } from './trust-score-review-logic.js';

/** What companies-house/trust-score/rescore's answer means on this card: the check works again, or why not. */
export function recheckNowResult(answer: LambdaAnswer): RescoreResult {
  const result = rescoreResult(answer);
  if (!result.ok) {
    // A failed fetch is this card's subject: say it failed again rather than only that Companies House was slow
    return answer.reason === 'FETCH_FAILED'
      ? { ok: false, message: 'It failed again. Check the lambda logs for the reason, then try again.' }
      : result;
  }
  // wentToReview is false when the new score matches the one already reviewed, so no review was queued
  return {
    ok: true,
    message:
      answer.wentToReview === false
        ? 'Re-checked: the Companies House check works again and the score has not changed. Mark this resolved once you know why it failed.'
        : 'Re-checked: the Companies House check works again, and the new score has gone to the trust-score review queue. Mark this resolved once you know why it failed.',
  };
}
